define('Store.Item.Price.Helper', [
	'underscore'
], function StoreItemPriceHelper(
	_
) {
	'use strict';

	return {
		baseprice: function basePrice(item, store) {
			var priceLevel = 'pricelevel' + store && _.isFunction(store.get) ? store.get('msrpPriceLevel') : '';
			if (store && _.isFunction(store.get) && store.get('retailField') && item
				&& ((_.isFunction(item.get) && item.get(store.get('retailField').toLowerCase()))
				|| (item[store.get('retailField').toLowerCase()]))) {
				return _.isFunction(item.get)
					? item.get(store.get('retailField').toLowerCase())
					: item[store.get('retailField').toLowerCase()];
			}
			return item && _.isFunction(item.get) ? item.get(priceLevel) : item[priceLevel];
		},
		onlinecustomerprice: function onlinePrice(item, store) {
			var priceLevel = 'pricelevel' + store && _.isFunction(store.get) && store.get('onlinePriceLevel');
			if (store && _.isFunction(store.get) && store.get('priceField') && item
				&& ((_.isFunction(item.get) && item.get(store.get('priceField').toLowerCase()))
				|| (item[store.get('priceField').toLowerCase()]))) {
				return _.isFunction(item.get)
					? item.get(store.get('priceField').toLowerCase())
					: item[store.get('priceField').toLowerCase()];
			}
			return item && _.isFunction(item.get) ? item.get(priceLevel) : item[priceLevel];
		},
		baseprice_formatted: function basePrice(item, store) {
			var priceLevel = 'pricelevel' + store.get('msrpPriceLevel') + '_formatted';
			if (store.get('retailField') && item
				&& ((_.isFunction(item.get) && item.get(store.get('retailField').toLowerCase() + '_formatted'))
				|| (item[store.get('retailField').toLowerCase() + '_formatted']))) {
				return _.isFunction(item.get)
					? item.get(store.get('retailField').toLowerCase() + '_formatted')
					: item[store.get('retailField').toLowerCase() + '_formatted'];
			}
			return item && _.isFunction(item.get) ? item.get(priceLevel) : item[priceLevel];
		},
		onlinecustomerprice_formatted: function onlinePrice(item, store) {
			var priceLevel = 'pricelevel' + store && _.isFunction(store.get) ? store.get('onlinePriceLevel') : '' + '_formatted';
			if (store && _.isFunction(store.get) && store.get('priceField') && item
				&& ((_.isFunction(item.get) && item.get(store.get('priceField').toLowerCase() + '_formatted'))
				|| (item[store.get('priceField').toLowerCase() + '_formatted']))) {
				return _.isFunction(item.get)
					? item.get(store.get('priceField').toLowerCase() + '_formatted')
					: item[store.get('priceField').toLowerCase() + '_formatted'];
			}
			return item && _.isFunction(item.get) ? item.get(priceLevel) : item[priceLevel];
		}
	};
});
